module.exports = __webpack_public_path__ + "img/EDS online login page.8082e577.png";